import React, { useMemo } from "react";
import { useServiceabilityLocationTree } from "./hooks/useServiceability";
import { FormLabel } from "newui/components/ui/FormLabel";
import { buildDisplayChips } from "./serviceability-utils";

interface ServiceabilityLocationDisplayProps {
	/* used as override for default text display ONLY */
	className?: string;
	label?: string;
	showCode?: boolean;
	stringOnly?: boolean;
	value: number[];
}

export const ServiceabilityLocationDisplay: React.FC<ServiceabilityLocationDisplayProps> = ({
	className,
	label = "Serviceability Locations",
	showCode = false,
	stringOnly = false,
	value,
}) => {
	const { values: tree, isLoading } = useServiceabilityLocationTree();

	const selectedIds = useMemo(() => new Set(value), [value]);

	const displayChips = useMemo(
		() => buildDisplayChips(selectedIds, tree, showCode),
		[selectedIds, tree, showCode],
	);

	const displayClasses = className ?? "text-sm text-gray-700";

	return (
		<div>
			{label && <FormLabel label={label} />}

			{isLoading ? (
				<p className="text-sm text-gray-400">Loading...</p>
			) : displayChips.length === 0 ? (
				<p className="text-sm text-gray-400">No locations selected</p>
			) : stringOnly ? (
				<p className={displayClasses}>
					{displayChips.map((chip) => chip.label).join(", ")}
				</p>
			)
				:
				(
					<div className="flex flex-wrap gap-1">
						{displayChips.map((chip) => (
							<span
								key={chip.id}
								className={`inline-flex items-center rounded border border-gray-200 bg-gray-50 px-2 py-0.5 ${displayClasses}`}
							>
								{chip.label}
							</span>
						))}
					</div>
				)}
		</div>
	);
};
